import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ManagePortalComponent } from '../manage-portal.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { environment } from 'src/environments/environment';
declare const Quill: any;
@Component({
  selector: 'app-manage-portal-dialog',
  templateUrl: './manage-portal-dialog.component.html',
  styleUrls: ['./manage-portal-dialog.component.scss']
})
export class ManagePortalDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('editorElem') editorElement!: ElementRef;
  @ViewChild('fileDropRef', { static: false }) fileDropRef!: ElementRef;
  fileName: any = '';
  fileType: any = '';
  imageAllData: any = [];
  putAPIurl: any;
  payloadURL = '';
  isEditMode = false;
  imgURL = '';
  sectionDropdown: any = [];
  submitButtonName = 'Submit';
  selectedSubTabName: any = '';
  showAlert = false;
  termEmpty = false;
  descriptionEmpty = false;
  tabsAllow: any = ['contactUs', 'contactUsEmail', 'privacyStatement', 'prismIntro', 'glossary', 'teams', 'ourPartners'];
  sourceHtml = '';
  contactEmailLink = '';
  isBydefault = false;
  clickImage = false;
  fileUploadInfo = '*File size limit: 5MB*';

  constructor(
    public dialogRef: MatDialogRef<ManagePortalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private commonService: CommonServiceService
  ) { }
  modalHead: any = '';
  selectedSection: any;
  selectedCatType: any = 'resource';
  titleData: any = '';
  teamMemberName: any = '';
  teamMemberDesignation: any = '';
  teamMemberAbout: any = '';
  descriptionData: any = '';
  rank = 1;

  termData: any = '';

  commonSection: any = {
    homepage : [
      {
        id: 1,
        sectionName: 'Slider',
      },
      {
        id: 2,
        sectionName: 'About Us',
      },
      {
        id: 3,
        sectionName: 'Our Partners',
      },
      {
        id: 4,
        sectionName: 'Our Impact',
      },
      {
        id: 5,
        sectionName: 'Impact Stories',
      },
      {
        id: 6,
        sectionName: 'Our Team',
      },
      {
        id: 7,
        sectionName: 'Contact Us',
      }
    ],
    resources: [
      {
        id: 1,
        sectionName: 'PRISM Resources',
      },
      {
        id: 2,
        sectionName: 'PRISM',
      },
      {
        id: 3,
        sectionName: 'PRISM Report',
      },
      {
        id: 4,
        sectionName: 'Sectors supported',
      },
      {
        id: 5,
        sectionName: 'MSMEs supported',
      },
    ],
    impactStories: [
      {
        id: 1,
        sectionName: 'Impact Stories 1',
      },
      {
        id: 1,
        sectionName: 'Impact Stories 2',
      },
      {
        id: 1,
        sectionName: 'Impact Stories 3',
      },
    ],
    glossary: [
      {
        id: 1,
        sectionName: 'Sourcing Brands'
      },
      {
        id: 1,
        sectionName: 'Goods Produced'
      },
    ],
    contactUs: [
      {
        id: 1,
        sectionName: 'Contact Us 1',
      },
      {
        id: 1,
        sectionName: 'Contact Us 2',
      }
    ]
  };
  libraryForm!: FormGroup;
  formBuilder: any;
  file: any;
  files: any = [];
  @ViewChild('fileSet', { static: true }) fileSet: any;
  fileUrl = [];
  videoUrl = '';

  editor: any;



  ngOnInit(): void {
    this.selectedSubTabName = this.data?.selectedSubTabName;
    // Getting two different keys for the section name which needs to be prefill in the Select Category column i.e, section.name and name.
    this.sectionDropdown = this.data?.sectionData.filter((ele: any) => ele['section.name'] || ele.name);
    this.isEditMode = this.data.editMode;
    this.setModalHead(this.data);

    if (this.data?.currentTab === 'contactUsEmail' && !this.isEditMode) {
      this.selectedSection = this.data?.contactUsSectionId || environment.contactUsSectionId;
    }
    if (this.data?.currentTab === 'privacyStatement' && !this.isEditMode) {
      this.selectedSection = this.data?.privacyStatementSectionId || environment.privacyStatementSectionId;
    }
    if (this.data?.currentTab === 'prismIntro' && !this.isEditMode) {
      this.selectedSection = this.data?.prismIntroSectionId || environment.prismIntroSectionId;
    }

    if (this.isEditMode){
      this.submitButtonName = 'Update';


      switch (this.data.currentTab){
        case 'homepage':
          this.selectedSection = this.data.data.sectionId;
          this.titleData = this.data.data.title;
          this.descriptionData = this.data.data.subTitle ? this.data.data.subTitle : '';
          this.imgURL = this.data.data.banner;

          break;
        case 'resources':

          if (this.data.selectedSubTabName === 'Category'){
            this.selectedCatType = this.selectedCatType;
            this.titleData = this.data.data.name;
            this.imgURL = this.data?.data?.image;

          }else if (this.data.selectedSubTabName === 'Sub Category'){
            this.selectedSection = this.data?.data?.categoryId;
            this.titleData = this.data.data.name;
          }else{
            this.selectedSection = this.data?.data?.subCategoryId;
            this.titleData = this.data.data.name;
            this.imgURL = this.data?.data?.link;

          }
          break;
        case 'impactStories':
          this.selectedSection = this.data?.data?.categoryId;
          this.titleData = this.data?.data?.title;
          this.descriptionData = this.data?.data?.description ? this.data?.data?.description : '';
          this.imgURL = this.data?.data?.banner;
          this.videoUrl = this.data?.data?.link ? this.data?.data?.link : '';
          this.rank = this.data?.data?.ranking ? this.data?.data?.ranking : 0;

          break;
        case 'contactUsEmail':
          this.contactEmailLink = this.data?.data?.link || '';
          this.selectedSection = this.data?.data?.sectionId;
          break;
        case 'privacyStatement':
          this.descriptionData = this.data?.data?.subTitle || '';
          this.selectedSection = this.data?.data?.sectionId;
          break;
        case 'prismIntro':
          this.descriptionData = this.data?.data?.subTitle || '';
          this.sourceHtml = this.data?.data?.subTitle || '';
          this.selectedSection = this.data?.data?.sectionId;
          break;
        case 'glossary':
          this.termData = this.data?.data?.term;
          this.descriptionData = this.data?.data?.definition ? this.data?.data?.definition : '';
          break;
        case 'teams':
          this.teamMemberName = this.data?.data?.name;
          this.teamMemberDesignation = this.data?.data?.designation;
          this.teamMemberAbout = this.data?.data?.about;
          this.imgURL = this.data?.data?.profile;
          this.rank = this.data?.data?.ranking ? this.data?.data?.ranking : 0;

          break;

        case 'ourPartners':
          this.teamMemberName = this.data?.data?.title;
          this.teamMemberAbout = this.data?.data?.description;
          this.imgURL = this.data?.data?.image;
          this.rank = this.data?.data?.ranking ? this.data?.data?.ranking : 0;

          break;

        case 'aboutUs':
          this.selectedSection = this.data.data.id;
          this.titleData = this.data.data.title;
          this.descriptionData = this.data.data.subTitle ? this.data.data.subTitle : '';
          this.imgURL = this.data.data.banner;
          this.videoUrl = this.data?.data?.link ? this.data?.data?.link : '';
          break;
      }

      this.termData = this.data.data.term;
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  setModalHead(option: any): void {
    switch (option?.currentTab) {
      case 'homepage':
        this.modalHead = 'Program Summary';
        break;

      case 'resources':
        this.modalHead = 'Resource';
        break;

      case 'impactStories':
        this.modalHead = 'Impact Story';
        break;

      case 'glossary':
        this.modalHead = 'Glossary';
        break;

      case 'contactUs':
        this.modalHead = 'Contact Us';
        break;

      case 'contactUsEmail':
        this.modalHead = 'Contact Email';
        break;

      case 'privacyStatement':
        this.modalHead = 'Privacy Statement';
        break;

      case 'prismIntro':
        this.modalHead = 'PRISM Intro';
        break;

      case 'teams':
        this.modalHead = 'Team Member';
        break;

      case 'ourPartners':
        this.modalHead = 'Partner';
        break;

      default:
        break;
    }
  }

  createForm(): void {
    this.libraryForm = this.formBuilder.group({
      files: ['', [Validators.required]],
    });
  }
  onFileDropped(event: any): void {
    this.clickImage = true;
    this.files = [];
    this.prepareFilesList(event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files: any): void {
    const maximumFileSize = 5 * 1024 * 1024; // 5MB in bytes
    const currentFileSize = files?.target?.files[0]?.size;

    if (currentFileSize > maximumFileSize){
      files.target.value = null;
      this.openSnackBar(['Please upload file under 5 MB !'] , '');
      return ;
    }

    this.clickImage = true;
    const payload = [{
        file_name: files.target.files[0].name,
        mime_type: files.target.files[0].type
      }];
    this.commonService.uploadImage(payload).subscribe((res: any) => {
        if (res.success){
          this.imageAllData = res.data;
          this.imageAllData.forEach((ele: any) => {
            this.putAPIurl = ele?.url;
            this.payloadURL = ele?.file_url;
            this.imgURL = ele?.file_url;
          });
          this.commonService.imagePUTapi(this.putAPIurl, files.target.files[0]).subscribe();
        }
      });


    this.files = [];
    this.prepareFilesList(files.target.files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number): void {
    if (this.fileDropRef) {
      this.fileDropRef.nativeElement.value = '';
    }
    this.files?.splice(index, 1);
    this.imgURL = '';
    this.payloadURL = '';
    if (this.files.length === 0) {
      this.libraryForm.reset();
      this.libraryForm.get('files')?.reset();
    }



  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number): void {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>): void {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */

  formatBytes(bytes: any, decimals: any): string {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  paylaterClick(): void {
  }

  submitClick(): void {
  }

  submitValues(): void {
  }

  submitModalData(): void {
      const userId = JSON.parse(sessionStorage.getItem('userdata') || '{}');
      if (!userId?.id) {
        this.openSnackBar(['User session is invalid. Please login again.']);
        return;
      }
      switch (this.data.currentTab){
        case 'homepage':
          {
          const sectionId = Number(this.selectedSection);
          if (sectionId == null || Number.isNaN(sectionId)) {
            this.openSnackBar(['Please select a valid section.']);
            return;
          }
          const homepayload = {
            title: this.titleData,
            subTitle: this.sanitizeRichTextOutput(this.descriptionData),
            sectionId,
            createdBy: userId?.id,
            slug: 'home',
            banner: this.payloadURL ? this.payloadURL : this.imgURL
          };
          this.commonService.createCms(homepayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success){
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;
          }
        case 'resources':
          if (this.selectedSubTabName === 'Category'){
            const resourcePayload = {
              name: this.titleData,
              image: this.payloadURL ? this.payloadURL : this.imgURL,
              types: this.selectedCatType,
              createdBy: userId?.id,
              isActive: true
            };
            this.commonService.createCategory(resourcePayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
              if (res.success){
                this.closeDialog(res);
              }
            }, (error: any) => {
              this.openSnackBar(error?.error?.message);
            });
          }else if (this.selectedSubTabName === 'Sub Category'){
            const categoryId = Number(this.selectedSection);
            if (categoryId == null || Number.isNaN(categoryId)) {
              this.openSnackBar(['Please select a valid category.']);
              return;
            }
            const resourcePayload = {
              name: this.titleData,
              categoryId,
              isActive: true,
              createdBy: userId?.id,
          };
            this.commonService.createSubCategory(resourcePayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success){
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          }else{
            const subCategoryId = Number(this.selectedSection);
            if (subCategoryId == null || Number.isNaN(subCategoryId)) {
              this.openSnackBar(['Please select a valid sub category.']);
              return;
            }
            const resourcePayload = {
              name: this.titleData,
              link: this.payloadURL ? this.payloadURL : this.imgURL,
              subCategoryId,
              isActive: true,
              createdBy: userId?.id
            };
            this.commonService.createSubCatReport(resourcePayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
              if (res.success){
                this.closeDialog(res);
              }
            }, (error: any) => {
              this.openSnackBar(error?.error?.message);
            });
          }
          break;
        case 'impactStories':
          if (this.rank == null){
            this.openSnackBar(['Rank cannot be empty']);
            return;
          }
          if (this.rank < 0 || this.rank === 0){
            this.openSnackBar(['Rank Field does not allow Zero(0) && Negative(-1,-2,...)']);
            return;
          }
          const categoryId = Number(this.selectedSection);
          if (categoryId == null || Number.isNaN(categoryId)) {
            this.openSnackBar(['Please select a valid category.']);
            return;
          }
          const impactPayload = {
            title: this.titleData,
            banner: this.payloadURL ? this.payloadURL : this.imgURL,
            description: this.sanitizeRichTextOutput(this.descriptionData),
            categoryId,
            createdBy: userId?.id,
            link: this.videoUrl,
           ...this.isEditMode && { ranking: this.rank}
          };

          this.commonService.createImpactStory(impactPayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success){
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;
        case 'glossary':
          const glossaryPayload = {
            term: this.termData,
            definition: this.sanitizeRichTextOutput(this.descriptionData),
            createdBy: userId?.id,
          };
          this.commonService.createGlossary(glossaryPayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success){
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;

        case 'teams':
          if (this.isEditMode) {
            if (this.rank == null) {
              this.openSnackBar(['Rank cannot be empty']);
              return;
            }
            if (this.rank < 0 || this.rank === 0) {
              this.openSnackBar(['Rank Field does not allow Zero(0) && Negative(-1,-2,...)']);
              return;
            }
          }
          const teamPayload = {
            cmsId: 7,
            name: this.teamMemberName,
            designation: this.teamMemberDesignation,
            profile: this.payloadURL ? this.payloadURL : this.imgURL,
            about: this.teamMemberAbout,
            isActive: true,
            createdBy: userId?.id,
            ...this.isEditMode && { ranking: this.rank }
          };
          this.commonService.createTeamMember(teamPayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success){
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;

        case 'ourPartners':
          if (this.rank < 0 || this.rank === 0){
            this.openSnackBar(['Rank Field does not allow Zero(0) && Negative(-1,-2,...)']);
            return;
          }
          const partnerPayload = {
            title: this.teamMemberName,
            description: this.teamMemberAbout,
            image: this.payloadURL ? this.payloadURL : this.imgURL,
            createdBy: userId?.id,
            ...this.isEditMode && {ranking: this.rank}
          };
          this.commonService.createNewPartner(partnerPayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success){
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;

        case 'contactUsEmail': {
          const email = (this.contactEmailLink || '').trim();
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(email)) {
            this.openSnackBar(['Please enter a valid email address']);
            return;
          }
          const selectedSectionId = Number(this.selectedSection);
          const sectionId = Number.isNaN(selectedSectionId)
            ? environment.contactUsSectionId
            : selectedSectionId || environment.contactUsSectionId;
          if (sectionId == null || Number.isNaN(sectionId)) {
            this.openSnackBar(['Contact Us section is not configured. Run backend seed or select a section.']);
            return;
          }
          const contactEmailPayload = {
            title: 'Contact Us Email',
            slug: 'contact-us-email',
            sectionId,
            link: email,
            isActive: true,
            createdBy: userId?.id,
          };
          this.commonService.createCms(contactEmailPayload, this.data.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success) {
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;
        }
        case 'privacyStatement': {
          const copy = this.sanitizeRichTextOutput((this.descriptionData || '').trim());
          if (!this.hasRichTextContent(copy)) {
            this.openSnackBar(['Privacy statement text is required']);
            return;
          }
          const selectedSectionId = Number(this.selectedSection);
          const sectionId = Number.isNaN(selectedSectionId)
            ? environment.privacyStatementSectionId
            : selectedSectionId || environment.privacyStatementSectionId;
          if (sectionId == null || Number.isNaN(sectionId)) {
            this.openSnackBar(['Privacy Statement section is not configured. Run backend seed or select a section.']);
            return;
          }
          const privacyPayload = {
            title: 'Privacy Statement',
            slug: 'privacy-statement',
            sectionId,
            subTitle: copy,
            isActive: true,
            createdBy: userId?.id,
          };
          this.commonService.createCms(privacyPayload, this.data.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success) {
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;
        }
        case 'prismIntro': {
          const copy = this.sanitizeRichTextOutput(this.getPrismIntroHtmlContent());
          if (!this.hasRichTextContent(copy)) {
            this.openSnackBar(['PRISM Intro page content is required']);
            return;
          }
          const selectedSectionId = Number(this.selectedSection);
          const sectionId = Number.isNaN(selectedSectionId)
            ? environment.prismIntroSectionId
            : selectedSectionId || environment.prismIntroSectionId;
          if (sectionId == null || Number.isNaN(sectionId)) {
            this.openSnackBar(['PRISM Intro section is not configured. Run backend seed or select a section.']);
            return;
          }
          const prismIntroPayload = {
            title: 'PRISM Intro',
            slug: 'prism-intro',
            sectionId,
            subTitle: copy,
            isActive: true,
            createdBy: userId?.id,
          };
          this.commonService.createCms(prismIntroPayload, this.data.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success) {
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;
        }
        case 'aboutUs':
          {
          const sectionId = Number(this.selectedSection);
          if (sectionId == null || Number.isNaN(sectionId)) {
            this.openSnackBar(['Please select a valid section.']);
            return;
          }
          const aboutUsPayload = {
            title: this.titleData,
            subTitle: this.sanitizeRichTextOutput(this.descriptionData),
            sectionId,
            createdBy: userId?.id,
            slug: 'home',
            banner: this.payloadURL ? this.payloadURL : this.imgURL,
            link: this.videoUrl
          };
          this.commonService.aboutUsMasterData(aboutUsPayload, this.data?.data?.id, this.isEditMode).subscribe((res: any) => {
            if (res.success){
              this.closeDialog(res);
            }
          }, (error: any) => {
            this.openSnackBar(error?.error?.message);
          });
          break;
          }
        default:
        break;
      }
  }

  closeDialog(response: any = ''): void {
    if (response) {
    this.openSnackBar(response?.message);
    }
    this.dialogRef.close();
  }

  openDocument(): void {
    window.open(this.imgURL);
  }
  isValidRank(rank: any): boolean{
    return rank < 0 || rank === 0;
  }

  ngAfterViewInit(): void {
    if (!this.editorElement?.nativeElement) {
      return;
    }
    this.editor = new Quill(this.editorElement.nativeElement, {
      theme: 'snow',
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ align: [] }],
          [{ list: 'ordered'}, { list: 'bullet' }],
          [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
          ['link', 'image'],
          ['custom-font-size'],  // Include the custom font size in the toolbar
        ]
      }
    });

    const initialContent = this.descriptionData;
    this.editor.clipboard.dangerouslyPasteHTML(initialContent);
    this.editor.on('text-change', () => {
      this.descriptionData = this.editor.root.innerHTML;
    });

    const fontSizeConfig = {
      container: [
        { label: 'Small', value: '12px' },
        { label: 'Normal', value: '16px' },
        { label: 'Large', value: '24px' },
        { label: 'Huge', value: '36px' }
      ]
    };

    Quill.register('formats/size', fontSizeConfig); // Update the module name
    this.editor.getModule('toolbar').addHandler('custom-font-size', (value: any) => {
      this.editor.format('size', value); // Use 'size' instead of 'custom-font-size'
    });
  }

  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: [className]
  });
}
isDisable(): boolean{
  let isValid = false;
  if (this.data?.currentTab === 'teams'){
     if (!this.teamMemberDesignation?.length || !this.teamMemberName?.length || !(this.imgURL?.length || this.payloadURL?.length) ||
      (this.isEditMode && (!this.rank || this.rank === 0 || this.rank < 0))){
        isValid =  true;
     }
     else{
      isValid = false;
     }
  }
  if (this.data?.currentTab === 'ourPartners'){
    if (!this.teamMemberAbout?.length || !this.teamMemberName?.length ||
      !(this.imgURL ?.length || this.payloadURL?.length) || (!this.rank || this.rank === 0 || this.rank < 0)){
       isValid =  true;
    }
    else{
     isValid = false;
    }
 }
  if (this.data?.currentTab === 'glossary'){
  const textPattern = /(?:^|>)[^<]*?(?=<|$)/g;
  const matches = this.descriptionData.match(textPattern);
  const unenclosedLetters = matches.filter((match: any) => !match.includes('<p>') && !match.includes('</p>'));
  const replacedArray = unenclosedLetters.map((item: any) => item.replace(/>/g, '')).some((item: any) => item.length > 0);
  if (!this.termData?.length || !replacedArray){
     isValid =  true;
  }
  else{
   isValid = false;
  }
}
  if (this.data?.currentTab === 'impactStories'){
  const textPattern = /(?:^|>)[^<]*?(?=<|$)/g;
  const matches = this.descriptionData.match(textPattern);
  const unenclosedLetters = matches.filter((match: any) => !match.includes('<p>') && !match.includes('</p>'));
  const replacedArray = unenclosedLetters.map((item: any) => item.replace(/>/g, '')).some((item: any) => item.length > 0);
  if (this.selectedSection === 0 || !this.titleData?.length || !replacedArray ||
    !(this.imgURL?.length || this.payloadURL?.length) || (!this.rank || this.rank === 0 || this.rank < 0)){
     isValid =  true;
  }
  else{
   isValid = false;
  }
}
  if (this.data?.selectedSubTabName === 'Category' && this.data?.currentTab === 'resources'){
  if (this.selectedSection === 0 || !this.titleData?.length || !(this.imgURL?.length || this.payloadURL?.length)){
     isValid =  true;
  }
  else{
   isValid = false;
  }
}
  if (this.data?.selectedSubTabName === 'Sub Category' && this.data?.currentTab === 'resources'){
  if (this.selectedSection === 0 || !this.titleData?.length || !(this.imgURL?.length || this.payloadURL?.length)){
     isValid =  true;
  }
  else{
   isValid = false;
  }
}
  if (this.data?.selectedSubTabName === 'Sub Category' && this.data?.currentTab === 'resources'){
  if (this.selectedSection === 0 || !this.titleData?.length){
     isValid =  true;
  }
  else{
   isValid = false;
  }
}
  if (this.data?.selectedSubTabName === 'Sub-Category Report' && this.data?.currentTab === 'resources'){
  if (this.selectedSection === 0 || !this.titleData?.length || !(this.imgURL?.length || this.payloadURL?.length)){
     isValid =  true;
  }
  else{
   isValid = false;
  }
}
  if (this.data?.currentTab === 'homepage' || this.data?.currentTab === 'aboutUs'){
  if (this.selectedSection === 0 || !this.titleData?.length ){
     isValid =  true;
  }
  else{
   isValid = false;
  }
}
  if (this.data?.currentTab === 'contactUsEmail') {
    const email = (this.contactEmailLink || '').trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const selectedSectionId = Number(this.selectedSection);
    const sectionId = Number.isNaN(selectedSectionId)
      ? environment.contactUsSectionId
      : selectedSectionId || environment.contactUsSectionId;
    isValid = !emailPattern.test(email) || (!this.isEditMode && (sectionId == null || Number.isNaN(sectionId)));
  }
  if (this.data?.currentTab === 'privacyStatement') {
    const selectedSectionId = Number(this.selectedSection);
    const sectionId = Number.isNaN(selectedSectionId)
      ? environment.privacyStatementSectionId
      : selectedSectionId || environment.privacyStatementSectionId;
    isValid = !this.hasRichTextContent(this.descriptionData) || (!this.isEditMode && (sectionId == null || Number.isNaN(sectionId)));
  }
  if (this.data?.currentTab === 'prismIntro') {
    const selectedSectionId = Number(this.selectedSection);
    const sectionId = Number.isNaN(selectedSectionId)
      ? environment.prismIntroSectionId
      : selectedSectionId || environment.prismIntroSectionId;
    isValid = !this.hasRichTextContent(this.getPrismIntroHtmlContent()) || (!this.isEditMode && (sectionId == null || Number.isNaN(sectionId)));
  }
  return isValid;

}

  private getPrismIntroHtmlContent(): string {
    const source = (this.sourceHtml || '').trim();
    if (source) {
      return source;
    }
    return (this.descriptionData || '').trim();
  }

  private sanitizeRichTextOutput(html: string): string {
    if (!html) { return html; }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('img').forEach((img: Element) => {
      img.removeAttribute('width');
      img.removeAttribute('height');
      (img as HTMLElement).style.removeProperty('width');
      (img as HTMLElement).style.removeProperty('height');
    });
    doc.querySelectorAll('table').forEach((table: Element) => {
      const parent = table.parentElement;
      if (parent && !parent.classList.contains('table-responsive-wrap')) {
        const wrapper = doc.createElement('div');
        wrapper.className = 'table-responsive-wrap';
        parent.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });
    return doc.body.innerHTML;
  }

  private hasRichTextContent(html: string): boolean {
    const textPattern = /(?:^|>)[^<]*?(?=<|$)/g;
    const matches = (html || '').match(textPattern);
    if (!matches) {
      return false;
    }
    const unenclosedLetters = matches.filter((match: string) => !match.includes('<p>') && !match.includes('</p>'));
    return unenclosedLetters.map((item: string) => item.replace(/>/g, '')).some((item: string) => item.length > 0);
  }

}
